import { cn } from '@/legacy-src/lib/utils'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Heading } from '@/src/domains/design-system/components/Heading'
import { Text } from '@/src/domains/design-system/components/Text'

const descriptionMap: Record<number, string> = {
  0: 'diagnosisTest.register.description.he',
  1: 'diagnosisTest.register.description.she',
}
export interface TherapistsPreviewInRegistrationTitleProps {
  nameVocative?: string
  sex?: number
}

export const TherapistsPreviewInRegistrationTitle = ({
  nameVocative,
  sex,
}: TherapistsPreviewInRegistrationTitleProps) => {
  const { t } = getTranslate()

  const desc = sex === undefined ? undefined : descriptionMap[sex]

  return (
    <>
      <Heading
        variant="3xl"
        element="h1"
        className={cn('text-center', {
          'mb-2': desc !== undefined,
          'mb-0': desc === undefined,
        })}
      >
        {t('diagnosisTest.register.titlePersonalised', { name: nameVocative })}
      </Heading>
      {desc === undefined ? null : (
        <Text element="p" className="mb-0 text-center">
          {t(desc)}
        </Text>
      )}
    </>
  )
}
